import { Navigate } from 'react-router-dom'

/**
 * /integraciones/presea (sin subruta) redirige a la primera sub-página (Cola).
 * El contenido viejo se dividió 24/06/26 en pages/presea/PreseaCola.jsx,
 * PreseaResolucionPage.jsx y PreseaMaestros.jsx.
 */
export default function PreseaPage() {
  return <Navigate to="/integraciones/presea/cola" replace />
}
